import React from "react";
import { Modal, Box, Typography, Link } from "@mui/material";

const modalContainerSx = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const modalContentSx = {
  backgroundColor: "background.paper",
  boxShadow: (theme) => theme.shadows[5],
  padding: "16px 32px 24px", // was theme.spacing(2, 4, 3)
  maxWidth: 400,
  textAlign: "center",
  width: "20em",
  borderRadius: "12px",
  paddingTop: "3rem",
  paddingBottom: "3rem",
};

const imageSx = {
  width: 100,
  height: 100,
  marginBottom: "16px", // was theme.spacing(2)
};

const titleSx = {
  marginBottom: "0.5rem !important",
  fontFamily: "Poppins-Medium !important",
  fontSize: "20px !important",
  fontStyle: "normal",
  fontWeight: "600 !important",
  lineHeight: "24px !important",
  letterSpacing: "0.15px !important",
  paddingLeft: "1.5rem !important",
  paddingRight: "1.5rem !important",
};

const subtitleSx = {
  marginTop: "1rem !important",
  marginBottom: "2rem !important",
  fontFamily: "Poppins-Regular !important",
  fontSize: "14px !important",
  fontStyle: "normal",
  fontWeight: "400 !important",
  lineHeight: "16px !important",
  letterSpacing: "0.4px !important",
};

function GetInTouchModal({ open, imageSrc, title, subtitle }) {
  return (
    <Modal open={open} sx={modalContainerSx}>
      <Box sx={modalContentSx}>
        {imageSrc && <Box component="img" src={imageSrc} alt="Modal Icon" sx={imageSx} />}
        <Typography variant="h2" sx={titleSx}>
          {title}
        </Typography>
        <Typography variant="h3" sx={subtitleSx}>
          {subtitle}
        </Typography>
        <Link href="/main/dashboard" underline="none" sx={{
          color: "var(--color-primitives-primary-500)"
        }}>
          Go To Home
        </Link>
      </Box>
    </Modal>
  );
}

export default GetInTouchModal;
